//import AOS from 'aos';

import {Header} from '../util/header';
import {Sliders} from '../scripts/sliders';
import {Accordion} from '../util/Accordion';
import { Archive } from '../scripts/Archive';

export default {
  init() {
    new Header()
    new Sliders()
    new Archive()
    new Accordion('.accordion--tab','.accordion--tab_content')
  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./js/routes/common.js